module.exports = __webpack_public_path__ + "img/company_back.6c9df398.png";